// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2WH5B","left":"InfoRow_left__26Yv2"};